
define('template!webshopFiltersDetailView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!filter) { ;
__p += '\n<div class="placeholder">' +
((__t = ( loading ? _.i18n('common.loading', null, 'Loading...') : error )) == null ? '' : __t) +
'</div>\n';
 } else { ;
__p += '\n<div class="header">\n    <div class="title">\n        <div class="name">' +
__e( filter.name ) +
'</div>\n        <div class="meta">\n            #' +
((__t = ( filter.id )) == null ? '' : __t) +
'\n            ';
 if (filter.code) { ;
__p += ' · ' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
': <b>' +
__e( filter.code ) +
'</b>';
 } ;
__p += '\n            · ' +
((__t = ( _.i18n('webshop.filters.group', null, 'Group') )) == null ? '' : __t) +
': ' +
__e( filter.group ) +
'\n            · ' +
((__t = ( filter.productCount )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('common.products', null, 'products') )) == null ? '' : __t) +
'\n        </div>\n        <div class="names">\n            ';
 _.each(filter.names, function (n, l) { ;
__p += '<span class="lang-name"><b>' +
((__t = ( l )) == null ? '' : __t) +
'</b> ' +
__e( n ) +
'</span>';
 }); ;
__p += '\n        </div>\n    </div>\n    <div class="tools">\n        <div class="edit-region"></div>\n        <div class="delete-region"></div>\n    </div>\n</div>\n\n';
 if (!filter.webshop) { ;
__p += '\n<div class="pim-warning">\n    ' +
((__t = ( _.i18n('webshop.filters.pimWarning', null, 'This filter comes from the PIM sync: when a product is pushed again, the PIM rewrites the names of the languages it sends and the product\'s links to this filter.') )) == null ? '' : __t) +
'\n</div>\n';
 } ;
__p += '\n\n<div class="values-header">\n    <div class="values-title">' +
((__t = ( _.i18n('webshop.filters.valuesTitle', null, 'Values') )) == null ? '' : __t) +
' (' +
((__t = ( values.length )) == null ? '' : __t) +
')</div>\n    <div class="add-value-region"></div>\n</div>\n\n<div class="values">\n    <div class="value head">\n        <div class="col-color"></div>\n        <div class="col-name">' +
((__t = ( _.i18n('common.name', null, 'Name') )) == null ? '' : __t) +
'</div>\n        <div class="col-code">' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
'</div>\n        <div class="col-param">' +
((__t = ( _.i18n('webshop.filters.paramShort', null, 'Param') )) == null ? '' : __t) +
'</div>\n        <div class="col-products">' +
((__t = ( _.i18n('common.products', null, 'Products') )) == null ? '' : __t) +
'</div>\n        <div class="col-tools"></div>\n    </div>\n    ';
 _.each(values, function (v) { ;
__p += '\n    <div class="value" data-id="' +
((__t = ( v.valueId )) == null ? '' : __t) +
'">\n        <div class="col-color">\n            ';
 if (v.color) { ;
__p += '<span class="swatch" style="background: ' +
((__t = ( v.color )) == null ? '' : __t) +
'" title="' +
((__t = ( v.color )) == null ? '' : __t) +
'"></span>';
 } ;
__p += '\n        </div>\n        <div class="col-name">\n            <div class="main">' +
__e( v.name ) +
' ';
 if (v.webshop) { ;
__p += '<span class="origin webshop">Webshop</span>';
 } ;
__p += '</div>\n            ';
 if (v.otherNames) { ;
__p += '<div class="others">' +
__e( v.otherNames ) +
'</div>';
 } ;
__p += '\n        </div>\n        <div class="col-code">' +
__e( v.code ) +
'</div>\n        <div class="col-param">' +
__e( v.param ) +
'</div>\n        <div class="col-products"><a class="products" title="' +
((__t = ( _.i18n('webshop.filters.manageProducts', null, 'Manage products') )) == null ? '' : __t) +
'">' +
((__t = ( v.productCount )) == null ? '' : __t) +
'</a></div>\n        <div class="col-tools">\n            <span class="edit" title="' +
((__t = ( _.i18n('common.edit', null, 'Edit') )) == null ? '' : __t) +
'"><i class="fa fa-pencil"></i></span>\n            <span class="delete" title="' +
((__t = ( _.i18n('common.delete', null, 'Delete') )) == null ? '' : __t) +
'"><i class="fa fa-trash"></i></span>\n        </div>\n    </div>\n    ';
 }); ;
__p += '\n    ';
 if (values.length === 0) { ;
__p += '\n    <div class="empty">' +
((__t = ( _.i18n('webshop.filters.noValue', null, 'No value yet') )) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

